import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
//import { ReportsService } from '../services/reportService/report.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { AddFormReports3CMapComponent } from 'src/app/middleware/common/FormReports3CMap/FormReports3CMap.component';
import { ReportService } from '../services/reportService/report.service';
import { RoleLevel } from '../services/reportService/setting.enum';

@Component({
  selector: 'app-manage-ProjectDataReports',
  templateUrl: './manage-ProjectDataReports.component.html',
  styleUrls: ['./manage-ProjectDataReports.component.scss'],
  providers: [DatePipe]
})

export class ManageProjectDataReportComponent implements OnInit {

  formDialog: FormGroup;
  updateformDialog: FormGroup;

  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
    OfficeIDList: [],
    officeID: 0
  };

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  currentUser: any;
  organizationId: string;
  responseHolder: any;
  folderList: any[] = [];
  value = '';
  paginatorTotalLength: any;
  //dataSource: any;
  dataCount: any;
  pageChangeEvent: any;
  pageIndex: any;
  pageSize: any;

  OfficeIDList: any = [];
  myOfficeID: any;
  ShowNoRecordFound: boolean = false;
  spinner: boolean = false;
  taskStatusID: number = 0;

  cType: number = 1;
  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  menuModulesList: any = [] = [];
  folderID: number = 0;
  FormReportfolderList: any = [] = [];
  ShowNoRecordFoundForms: boolean = false;
  databaseId: any;
  templateName: string = "";
  aITemplateList: any = [] = [];
  filterText: string = "";
  aiAutomationTemplateID: number = 0;
  showAddUpdateButton: boolean = true;
  PromptTemplateName: string = "";
  PromptTemplateID: number = 0;
  FieldTemplateName: string = "";
  FieldTemplateID: number = 0;
  formID: number = 0;
  searchKeyword: string = "";
  selectedDateRanges: any;
  ProjectStatus: number = 0;
  projects: any = [] = [];
  rolesAsssign: any[] = [];
  showSuperAdmin:boolean=false;
  showOrganizationAdmin:boolean=false;
  showOfficeAdmin:boolean=false;
  showUserAdmin:boolean=false;
  UsersList: any[] = [];

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
    private toastr: ToastrService, private statusConst: StatusConstant,
    private reusableClass: ReusableClasses, private dialog: MatDialog,
    private reportsService: ReportService, private encryptionAlgo: EncryptionService,
    private datePipe: DatePipe,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Core'
    );
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;     
    }

    SelectedContact = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Contact'
    );
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;      
    }

    SelectedCompany = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Company'
    );
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;   
    }
    this.GetProjectsReport();

    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles")); 
    
    var superadmin = [];
    // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
    superadmin = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);   
    if (superadmin.length > 0) {
      this.showSuperAdmin = true;
    } else {
      this.showSuperAdmin = false;
    }

    var OrganizationAdmin = [];   
    OrganizationAdmin = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OrganizationAdmin || 
    m.roleLevel == RoleLevel.SuperAdmin);
    if (OrganizationAdmin.length > 0) {
      this.showOrganizationAdmin = true;
      this.getOfficeList();
    } else {
      this.showOrganizationAdmin = false;
    }

    var OfficeAdmin = [];   
    OfficeAdmin = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OfficeAdmin);
    if (OfficeAdmin.length > 0) {
      this.showOfficeAdmin = true;
    } else {
      this.showOfficeAdmin = false;
    }

    var user = [];   
    user = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin ||
    m.roleLevel == RoleLevel.OrganizationAdmin || m.roleLevel == RoleLevel.OfficeAdmin);
    if (user.length > 0) {
      this.showUserAdmin = true;
    } else {
      this.showUserAdmin = false;
    }
  }

  // For Show Project Data

  GetProjectsReport() {
    this.loaderService.show();
    var ReqModel = {
      formID: 0,
      projectStatus: 0,
      searchKeyword: "",
      searchDateRange:null,
      //  searchDateRange: {
      //   from: null,
      //   to: null
      //  }, 
      documentUrl: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.reportsService.getProjectsReport(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.projects = this.responseHolder.data;
          this.projects.forEach(element => {
            element.createdOn = this.datePipe.transform(element.createdOn, "MM/dd/yyyy hh:mm:ss a");
          });
        } else {
          this.ShowNoRecordFound = true;
          this.projects = [];
          this.loaderService.hide();
        }
      } else {
        this.ShowNoRecordFound = true;
        this.projects = [];
        this.loaderService.hide();
      }
    });
  }


  downloadAsZip(project: any) {
    this.loaderService.show();
    var ReqModel = {
      projectID: project.projectID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
      Urls: project.linksToCompletedDocuent
    };
    this.reportsService.DownloadMultipleAsZipAsync(ReqModel)
      .then(blob => this.triggerDownload(blob, project.projectName))
      .catch(error => {
        this.loaderService.hide();
        console.error('Error fetching the zip file:', error);
      });
  }

  triggerDownload(blob: Blob, docName: any = 'Project') {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = docName + ' Completed Doc' + '.zip';
    a.click();
    URL.revokeObjectURL(objectUrl);
    this.loaderService.hide();
  }


  SendRemainder(project: any) {
    this.loaderService.show();
    let reqModel = {
      GroupRelationParticipantMappingID: 0,
      ProjectID: project.projectID,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      officeID: this.myOfficeID,
      databaseID: this.databaseId,
      contactId: 0,
    }
    this.reportsService.ResendRemainderProjectReport(reqModel).subscribe(response => {
      this.loaderService.hide();
      if (response) {
        this.toastr.success('The reminder has been sent.');
      } else {
        this.toastr.warning('The project group is not active yet.');
      }
    });
  }

  mapPlaceHolder(project: any) {
    var datasplit = [];
    var email: string = "";
    datasplit = project.participants.split(',');
    if (datasplit.length > 0) {
      email = datasplit[0];
    }
    const dialogRef = this.dialog.open(AddFormReports3CMapComponent, {
      data: {
        email: email,
        projectID: project.projectID,
        formID: Number(this.formID),
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {

      }
    });
  }


  Search(filterValue) {
    this.filterText = filterValue;
    this.GetProjectsReport();
  }

  clearFilter() {
    this.value = "";
    this.filterText = "";
    this.GetProjectsReport();
  }

  close() {
    this.ParticipantList = [];
    this.dialog.closeAll();
  }

  emailAdvSearch: string = "";
  ProjectName: string = "";
  subject: string = "";
  selectedFormId: number = 0;
  formList: any = [] = [];
  userData: any[] = [];
  sentchecked: boolean = false;
  inProgresschecked: boolean = false;
  completedchecked: boolean = false;
  userListResponseHolder: any = [] = [];
  projectDocuments: any = [] = [];
  ResponseHolderDetails: any = [] = [];
  documentId: number = 0;
  sentby: string = "";
  isAdvancedSearch: boolean = false;
  fromDate: any;
  toDate: any;
  ParticipantList: any = [] = [];
  documentSelected: number = 0;
  showCustomField: boolean = false;
  showCustomColumninList: any = [] = [];
  rowDataList: any = [] = [];
  selectedDocumentId: number = 0;
  displayColumn: any = [] = [];
  noRecordFoundCustomField: boolean;
  SubmitColumnsButton: boolean = false;
  showDisplayColumn: boolean = false;

  OrgnizationList: any = [] = [];
  OrgnizationListResponseHolder: any = [] = [];

  OrgOfficeList: any = [] = [];
  OrgOfficeListResponseHolder: any = [] = [];

  selectedOrganizationId: number = 0;
  selectedOfficeId: number = 0;
  selecteduserId:string="";

  applyAdvFilter(templateRef: TemplateRef<any>) {
    this.isAdvancedSearch = true;
    this.sentchecked = false;
    this.completedchecked = false;
    this.inProgresschecked = false;
    this.userData = [];
    // this.emailAdvSearch = "";
    //this.selectedFormId = 0;
    this.fromDate = "";
    this.toDate = "";
    this.formList = [];
    this.documentId = 0;
    //this.documentSelected = 0;

    // this.OrgnizationList=[];
    // this.OrgOfficeList=[];
    // this.UsersList=[];

    // this.selectedOfficeId=0;
    // this.selectedOrganizationId=0;
    // this.selecteduserId=0;

    this.GetFormUseReports();
    this.getOrgListDropdown();
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  GetFormUseReports() {
    var organizationIds:number=0;
       var officeIds:number=0;
       var UserIds:string="";
   
       if(this.selectedOrganizationId>0){
         organizationIds = this.selectedOrganizationId;
       }
       if(this.selectedOrganizationId==0){
         organizationIds = Number(this.organizationId);
       }
   
       if(this.selectedOfficeId>0){
         officeIds = this.selectedOfficeId;
       }
       if(this.selectedOfficeId==0){
         officeIds = Number(this.myOfficeID);
       }
   
       if(this.selecteduserId!=""){
         UserIds = this.selecteduserId;
       }
       if(this.selecteduserId==""){
         UserIds = this.currentUser.UID;
       }   
    var ReqModel = {
      keyword: this.filterText,
      userID: UserIds,//this.currentUser.UID,
      officeID: officeIds,//this.myOfficeID,
      organizationID: organizationIds,//Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.reportsService.getFormUseReports(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.formList = this.responseHolder.data;
          if (this.formList == null) {
            this.formList = [];
          }
          if (this.formList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.formList = [];
        }
      }
      else {
        this.formList = [];
      }
    });
  }


  formNameSelection(event) {
    this.selectedFormId = Number(event.value);
    this.GetProjectDocument();
  }

  documentSelection(event) {
    this.documentSelected = Number(event.value);
  }

  GetProjectDocument() {

    var organizationIds:number=0;
       var officeIds:number=0;
       var UserIds:string="";
   
       if(this.selectedOrganizationId>0){
         organizationIds = this.selectedOrganizationId;
       }
       if(this.selectedOrganizationId==0){
         organizationIds = Number(this.organizationId);
       }
   
       if(this.selectedOfficeId>0){
         officeIds = this.selectedOfficeId;
       }
       if(this.selectedOfficeId==0){
         officeIds = Number(this.myOfficeID);
       }
   
       if(this.selecteduserId!=""){
         UserIds = this.selecteduserId;
       }
       if(this.selecteduserId==""){
         UserIds = this.currentUser.UID;
       }   

    var ReqModel = {
      projectID: Number(this.selectedFormId),
      type: 2,// 1 for Project and 2 for Template
      UserID: UserIds,//this.currentUser.UID,
      OrganizationID: organizationIds,//Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      OfficeIDList: this.OfficeIDList,
      officeID:officeIds, //this.myOfficeID,
      isSent: false//(sessionStorage.getItem("isSent") == null || sessionStorage.getItem("isSent") == undefined) ? false : (sessionStorage.getItem("isSent") == 'true' ? true : false)
    };
    this.reportsService.GetProjectDocuments(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          let data = response.data;
          this.projectDocuments = data.documents;
          if (this.projectDocuments.length > 0) {
            let getData: any;
            if (this.projectDocuments && this.projectDocuments.length > 0) {
              getData = this.projectDocuments[0]; // Ensure projectDocuments[0] exists
              if (getData != null) {
                this.documentSelected = getData.projectDocumentID;
              }
            }
          }
        } else {
          this.projectDocuments = [];
        }
      } else {
        this.projectDocuments = [];
      }
    });
  }

  clear(){
    this.selectedOrganizationId=0;
    this.selectedOfficeId=0;
    this.selectedFormId=0;
    this.documentSelected=0;
    this.selecteduserId=""; 
    this.emailAdvSearch=""; 
  }


  SearchRecord() {
    this.showCustomField = true;

    var organizationIds:number=0;
    var officeIds:number=0;
    var UserIds:string="";

    if(this.selectedOrganizationId>0){
      organizationIds = this.selectedOrganizationId;
    }
    if(this.selectedOrganizationId==0){
      organizationIds = Number(this.organizationId);
    }

    if(this.selectedOfficeId>0){
      officeIds = this.selectedOfficeId;
    }
    if(this.selectedOfficeId==0){
      officeIds = 0;//Number(this.myOfficeID);
    }

    if(this.selecteduserId!=""){
      UserIds = this.selecteduserId;
    }
    if(this.selecteduserId==""){
      UserIds = "";//this.currentUser.UID;
    }

    var ReqModel = {
      formID: Number(this.selectedFormId),
      documentID: Number(this.documentSelected),
      userID: UserIds,//this.currentUser.UID,
      organizationID: Number(organizationIds),
      databaseID: Number(this.databaseId),
      officeIDList: this.OfficeIDList,
      officeID: officeIds,
      searchKey: this.emailAdvSearch,
    };
    this.loaderService.show();
    this.reportsService.GetPDFFormReport(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.ResponseHolderDetails = response;
        this.displayColumn = [];
        this.showCustomColumninList = [];
        this.rowDataList = [];
        this.dialog.closeAll();
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          this.ResponseHolderDetails = response.data.reportColumns;
          if (this.ResponseHolderDetails != null) {
            this.ResponseHolderDetails.map((res) => {
              if (res.fieldName == "") {
                res.fieldName = res.fieldTypeName;
              }
              return res;
            });
            this.displayColumn = this.ResponseHolderDetails;
          }
        
          if (response.data.reportDocs != null) {
            this.rowDataList = response.data.reportDocs;
          }
          if (response.data.reportDocs == null) {
            this.rowDataList = [];
            this.noRecordFoundCustomField = true;
          }

          this.showCustomColumninList = this.displayColumn.filter(x => x.isDisplay == true);

          if(this.showCustomColumninList.length>0){
            this.showDisplayColumn = true;
          }else{
            this.showDisplayColumn = false;
          }
          var obj4 = {
            fieldName: "Status",
            fieldTypeName: "Project Status",
            id: "Project Status",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj4);

          var obj3 = {
            fieldName: "Participant Emails",
            fieldTypeName: "Participant Emails",
            id: "Participant Emails",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj3);

          var obj2 = {
            fieldName: "Name",
            fieldTypeName: "Participant Name",
            id: "Participant Name",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj2);

          var obj1 = {
            fieldName: "Date",
            fieldTypeName: "Created On",
            id: "Created On",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj1);

          var obj5 = {
            fieldName: "Project Name",
            fieldTypeName: "Project Name",
            id: "Project Name",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj5);

          var obj55 = {
            fieldName: "From",
            fieldTypeName: "From",
            id: "From",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj55);

          var obj6 = {
            fieldName: "Docs link",
            fieldTypeName: "Docs link",
            id: "Docs link",
            isDisplay: true,
            viewOrder: 0
          }

          this.showCustomColumninList.push(obj6);

          var obj7 = {
            fieldName: "Docs",
            fieldTypeName: "Docs",
            id: "Docs",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.push(obj7);

          var obj88 = {
            fieldName: "Type",
            fieldTypeName: "Type",
            id: "Type",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.push(obj88);

          var obj8 = {
            fieldName: "Action",
            fieldTypeName: "Action",
            id: "Action",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.push(obj8);

          this.loaderService.hide();
        } else {
          this.displayColumn = [];
          this.showCustomColumninList = [];
          this.rowDataList = [];
          this.loaderService.hide();
        }
      } else {
        this.displayColumn = [];
        this.showCustomColumninList = [];
        this.rowDataList = [];
        this.loaderService.hide();
      }
    });
  }


  getFieldColumnValues(item, FieldColumn) {
    if (FieldColumn.id == "Project Name") {
      return item.projectName;
    }
    if (FieldColumn.id == "Project Name") {
      return item.projectName;
    }
    if (FieldColumn.id == "Created On") {
      return this.datePipe.transform(item.createdOn, "MM/dd/yyyy hh:mm:ss a");;
    }
    if (FieldColumn.id == "Participant Name") {
      return item.name;
    }
    if (FieldColumn.id == "Participant Emails") {
      return item.email;
    }
    if (FieldColumn.id == "Project Status") {
      return item.projectStatus;
    }
    if (item.fields != null) {
      var data = [];
      data = item?.fields.filter(x => x.id == FieldColumn.id);
      if (data != undefined) {
        if (data.length > 0) {
          if (data[0].val != "") {
            return data[0].val;
          } else {
            return '--';
          }
        } else {
          return '--';
        }
      }

    }
  }

  mapPlaceHolderCustom(project: any) {
    var datasplit = [];
    var email: string = "";
    datasplit = project.email.split(',');
    if (datasplit.length > 0) {
      email = datasplit[0];
    }
    const dialogRef = this.dialog.open(AddFormReports3CMapComponent, {
      data: {
        email: email,
        projectID: project.projectID,
        formID: Number(this.formID),
        pType: Number(project.pType),
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        //this.title= "Document Data";  
        this.showCustomField = true;
        //this.showDisplayColumn=false;
        this.displayColumn = [];
        //this.datatable=[];
        this.GetProjectDocument();
      }
    });
  }

  SearchFilter() {

  }

  downloadAsZipProject(project: any) {
    this.loaderService.show();
    var ReqModel = {
      projectID: project.projectID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
      Urls: project.finalDocuments
    };
    this.reportsService.DownloadMultipleAsZipAsync(ReqModel)
      .then(blob => this.triggerDownload(blob, project.projectName))
      .catch(error => {
        this.loaderService.hide();
        console.error('Error fetching the zip file:', error);
      });
  }

  resendEmailtoParticipants(project: any) {
    let reqModel = {
      projectID: project.projectID,
      pType: project.pType,
      emails: project.participants,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.reportsService.resendEmailtoParticipants(reqModel).subscribe(response => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        this.loaderService.hide();
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          this.toastr.success('Mail sent successfully', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  applyFilter(templateRef: TemplateRef<any>) {
    //this.SubmitColumnsButton = false;   
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  onSubmitColumns() {
    if (this.displayColumn.length > 0) {
      var newTable = [];
      var fields = [];
      newTable = this.displayColumn;
      if (newTable.length > 0) {
        for (let i = 0; i < newTable.length; i++) {
          var obj = {
            "id": newTable[i].id,
            "fieldName": newTable[i].fieldName,
            "fieldTypeName": newTable[i].fieldTypeName,
            "viewOrder": 0,
            "isDisplay": newTable[i].isDisplay,
          }
          fields.push(obj);
        }
      }
    }

    var organizationIds:number=0;
    var officeIds:number=0;
    var UserIds:string="";

    if(this.selectedOrganizationId>0){
      organizationIds = this.selectedOrganizationId;
    }
    if(this.selectedOrganizationId==0){
      organizationIds = Number(this.organizationId);
    }

    if(this.selectedOfficeId>0){
      officeIds = this.selectedOfficeId;
    }
    if(this.selectedOfficeId==0){
      officeIds = Number(this.myOfficeID);
    }

    if(this.selecteduserId!=""){
      UserIds = this.selecteduserId;
    }
    if(this.selecteduserId==""){
      UserIds = this.currentUser.UID;
    }

    var ReqModel = {
      fields: fields,
      formID: Number(this.selectedFormId),
      documentID: Number(this.documentSelected),
      userID: UserIds,//this.currentUser.UID,
      organizationID: Number(organizationIds),//Number(this.organizationId),
      officeID: officeIds,//this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.reportsService.addPDFFormUserSetting(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        this.loaderService.hide();
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          this.toastr.success('Record save successfully', '', {
            timeOut: 3000,
          });
          this.close();
          this.getFormJsonFields(this.documentSelected);
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  getFormJsonFields(documentId) {
    var organizationIds:number=0;
    var officeIds:number=0;
    var UserIds:string="";

    if(this.selectedOrganizationId>0){
      organizationIds = this.selectedOrganizationId;
    }
    if(this.selectedOrganizationId==0){
      organizationIds = Number(this.organizationId);
    }

    if(this.selectedOfficeId>0){
      officeIds = this.selectedOfficeId;
    }
    if(this.selectedOfficeId==0){
      officeIds = Number(this.myOfficeID);
    }

    if(this.selecteduserId!=""){
      UserIds = this.selecteduserId;
    }
    if(this.selecteduserId==""){
      UserIds = this.currentUser.UID;
    }

    var ReqModel = {
      formID: Number(this.selectedFormId),
      documentID: Number(documentId),
      userID: UserIds,//this.currentUser.UID,
      organizationID: Number(organizationIds),//Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeIDList: this.OfficeIDList,
      officeID: officeIds,//this.myOfficeID,
      searchKey: this.searchKeyword,
    };
    this.loaderService.show();
    this.reportsService.GetPDFFormReport(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.ResponseHolderDetails = response;
        this.displayColumn = [];
        this.showCustomColumninList = [];
        this.rowDataList = [];
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          this.ResponseHolderDetails = response.data.reportColumns;
          if (this.ResponseHolderDetails != null) {
            this.ResponseHolderDetails.map((res) => {
              if (res.fieldName == "") {
                res.fieldName = res.fieldTypeName;
              }
              return res;
            });
            this.displayColumn = this.ResponseHolderDetails;
          }

          if (response.data.reportDocs != null) {
            this.rowDataList = response.data.reportDocs;
          }
          if (response.data.reportDocs == null) {
            this.rowDataList = [];
            this.noRecordFoundCustomField = true;
          }

          this.showCustomColumninList = this.displayColumn.filter(x => x.isDisplay == true);

          var obj4 = {
            fieldName: "Status",
            fieldTypeName: "Project Status",
            id: "Project Status",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj4);

          var obj3 = {
            fieldName: "Participant Emails",
            fieldTypeName: "Participant Emails",
            id: "Participant Emails",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj3);

          var obj2 = {
            fieldName: "Name",
            fieldTypeName: "Participant Name",
            id: "Participant Name",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj2);

          var obj1 = {
            fieldName: "Date",
            fieldTypeName: "Created On",
            id: "Created On",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj1);

          var obj5 = {
            fieldName: "Project Name",
            fieldTypeName: "Project Name",
            id: "Project Name",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj5);

          var obj55 = {
            fieldName: "From",
            fieldTypeName: "From",
            id: "From",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.unshift(obj55);

          var obj6 = {
            fieldName: "Docs link",
            fieldTypeName: "Docs link",
            id: "Docs link",
            isDisplay: true,
            viewOrder: 0
          }

          this.showCustomColumninList.push(obj6);

          var obj7 = {
            fieldName: "Docs",
            fieldTypeName: "Docs",
            id: "Docs",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.push(obj7);

          var obj88 = {
            fieldName: "Type",
            fieldTypeName: "Type",
            id: "Type",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.push(obj88);

          var obj8 = {
            fieldName: "Action",
            fieldTypeName: "Action",
            id: "Action",
            isDisplay: true,
            viewOrder: 0
          }
          this.showCustomColumninList.push(obj8);

          this.loaderService.hide();
        } else {
          this.displayColumn = [];
          this.showCustomColumninList = [];
          this.rowDataList = [];
          this.loaderService.hide();
        }
      } else {
        this.displayColumn = [];
        this.showCustomColumninList = [];
        this.rowDataList = [];
        this.loaderService.hide();
      }
    });
  }

  changedToggle(items, event) {
    this.SubmitColumnsButton = true;
    if (this.displayColumn.length > 0) {
      this.displayColumn.find((item) => item.id == items.id).isDisplay = event.checked;
    }
  }

  getOrgListDropdown() {
    this.reportsService.getOrgs().subscribe(response => {
      if (response) {
        this.OrgnizationListResponseHolder = response;
        if (this.OrgnizationListResponseHolder.status == this.statusConst.statusSuccess) {
          this.OrgnizationList = this.OrgnizationListResponseHolder.data;
        }
      }
    });
  }

  getOfficeList() {
    this.UsersList=[];
    var reqModel = {
      organizationID: Number(this.organizationId)
    }
    this.reportsService.getOrgOffices(reqModel).subscribe(response => {
      if (response) {
        this.OrgOfficeListResponseHolder = response;
        if (this.OrgOfficeListResponseHolder.status == this.statusConst.statusSuccess) {
          this.OrgOfficeList = this.OrgOfficeListResponseHolder.data;
          this.selectedOrganizationId = Number(this.organizationId);
          this.GetFormUseReports();   
        }
      }
    })
  }


  getOffice(e) {
    this.UsersList=[];
    var reqModel = {
      organizationID: Number(e.value)
    }
    this.reportsService.getOrgOffices(reqModel).subscribe(response => {
      if (response) {
        this.OrgOfficeListResponseHolder = response;
        if (this.OrgOfficeListResponseHolder.status == this.statusConst.statusSuccess) {
          this.OrgOfficeList = this.OrgOfficeListResponseHolder.data;
          this.selectedOrganizationId = Number(e.value);
        
        }
      }
    })
  }

  selectOffice(e) {
    this.selectedOfficeId = Number(e.value);
    this.UsersList=[];
    this.getUsersList();
    this.GetFormUseReports();
  }

  getUsersList() {
    var reqModel = {    
      pageIndex : 0,
      pageSize :5000,
      databaseID : Number(this.databaseId),
      organizationID : this.selectedOrganizationId,
      OfficeIDList : this.OfficeIDList,
      officeID : this.selectedOfficeId,
      userID : this.currentUser.UID
    }
    this.reportsService.getUserList(reqModel).subscribe(response => {
      if (response) {
        this.userListResponseHolder = response.data.userModel;
        if(this.userListResponseHolder!=null){
          this.userListResponseHolder.map((res) => {
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }            
            return res;
          });        
          this.UsersList = response.data.userModel;         
        }
      }
    })
  }

  selectUser(e) {
    this.selecteduserId = e.value;
    this.GetFormUseReports();
  }
  
}

